    <img [src]="imageUrl"
         (loadstart)="onLoadStarted()"
         (change)="onLoadStarted()"
         (load)="onSuccess()"
         (error)="onError()"
         height="height"
         width="width"
         [alt]="alt"
         [ngClass]="{'hidden': !imageUrl  || isLoaded === false}"
    />
